import styled, { css } from "styled-components";
import { Theme } from "@tvg/design-system";
import { Layout } from "./types";

export const PicksSelectorContainer = styled.div<{
  isDisabled?: boolean;
  minWidth?: number;
}>`
  display: flex;
  flex-direction: column;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `};
  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth - 40}px;
    `}
`;

export const PicksSelectorColumnContainer = styled.div<{
  isHidden?: boolean;
  isSticky?: boolean;
  hasScrolled?: boolean;
}>`
  display: ${({ isHidden }) => (isHidden ? "none" : "flex")};
  flex-direction: column;
  flex: 0 0 44px;
  background: var(--fd-colors-background-layer);
  height: 100%;
  ${({ isSticky, hasScrolled }) =>
    isSticky &&
    css`
      position: sticky;
      left: 0;
      z-index: 8;
      box-shadow: ${hasScrolled
        ? "8px -6px 16px -2px var(--fd-colors-core-black-tint-030)"
        : "none"};
    `}
`;

export const PicksSelectorRunnerInfoColumnContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 0;
`;

export const PicksSelectorHeaderEntryContainer = styled.div<{
  isSelected?: boolean;
  isHidden?: boolean;
  isSticky?: boolean;
  hasScrolled?: boolean;
}>`
  width: 44px;
  display: ${({ isHidden }) => (isHidden ? "none" : "flex")};
  flex: 0 0 44px;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blue["200"]};
  box-shadow: inset 0 -1px 0 ${({ theme }) => theme.colors.blue["200"]};
  background: var(--fd-colors-background-layer);
  ${({ isSelected, theme }) =>
    isSelected && `background: ${theme.colors.blue["100"]};`}
  ${({ isSticky, hasScrolled, theme }) =>
    isSticky &&
    css`
      position: sticky;
      left: 0;
      z-index: 9;
      border-bottom-width: ${hasScrolled ? 2 : 1}px;
      box-shadow: ${hasScrolled
        ? "8px 0px 16px -2px var(--fd-colors-core-black-tint-030)"
        : `inset 0 -1px 0 ${theme.colors.blue["200"]}`};
    `}
`;

export const PicksSelectorEntryContainer = styled.div<{ layout: Layout }>`
  width: 44px;
  height: ${({ layout }) => (layout === Layout.CONDENSED ? "36px" : "68px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid
    ${(props: { theme: Theme }) => props.theme.colors.blue["100"]};
`;

export const PicksSelectorSaddleContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PicksSelectorEntryLabelContainer = styled.div<{
  isAlternatesView: boolean;
}>`
  width: 44px;
  display: flex;
  justify-content: center;
  ${({ isAlternatesView }) =>
    isAlternatesView
      ? css`
          height: 25px;
          margin-top: auto;
          margin-bottom: var(--fd-space-space-4);
        `
      : css`
          padding-top: 6px;
          align-items: center;
          height: 33px;
        `}
`;
export const PickSelectorHeader = styled.div`
  flex: 0 0 85px;
  min-height: fit-content;
  display: flex;
  background: ${(props: { theme: Theme }) =>
    props.theme.colors.blue_accent["000"]};
  box-shadow: inset 0 -2px 0 ${(props: { theme: Theme }) => props.theme.colors.blue["200"]};
`;

export const PickSelectorMainContainer = styled.div`
  flex: 1;
  display: flex;
`;

export const PicksSelectorRaceHeaderContainer = styled.div`
  max-height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const KeyIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
`;
